var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2154_19268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3953 8.74359C14.6801 10.9689 15.4452 13.1887 15.6572 14.9665C15.7634 15.8563 15.7283 16.6129 15.5677 17.1966C15.4079 17.7776 15.1342 18.1561 14.781 18.36C14.4278 18.564 13.9632 18.6118 13.3801 18.4597C12.7943 18.3068 12.1215 17.9589 11.404 17.4221C9.97035 16.3496 8.43056 14.5771 7.14575 12.3518C5.86095 10.1264 5.09582 7.90664 4.88379 6.1288C4.77767 5.23903 4.81279 4.48242 4.97331 3.89873C5.13311 3.31768 5.40682 2.93917 5.76003 2.73524C6.11323 2.53132 6.57789 2.48353 7.16098 2.63567C7.74674 2.7885 8.41954 3.13638 9.13707 3.67318C10.5707 4.74572 12.1105 6.51823 13.3953 8.74359Z",
    stroke: "#53C1DE",
    strokeWidth: 0.895405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.14578 8.74359C5.86096 10.9689 5.09583 13.1887 4.88379 14.9665C4.77766 15.8563 4.81279 16.6129 4.97331 17.1966C5.13311 17.7776 5.40682 18.1561 5.76003 18.36C6.11324 18.564 6.57789 18.6118 7.16101 18.4597C7.74671 18.3068 8.41958 17.9589 9.13704 17.4221C10.5707 16.3496 12.1104 14.5771 13.3953 12.3518C14.6801 10.1264 15.4452 7.90664 15.6573 6.1288C15.7634 5.23903 15.7282 4.48242 15.5677 3.89873C15.4079 3.31768 15.1342 2.93917 14.781 2.73524C14.4278 2.53132 13.9631 2.48353 13.38 2.63567C12.7943 2.7885 12.1215 3.13638 11.404 3.67318C9.97039 4.74572 8.43059 6.51823 7.14578 8.74359Z",
    stroke: "#53C1DE",
    strokeWidth: 0.895405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2762 6.93994C7.70662 6.93994 5.4017 7.38719 3.75604 8.0925C2.93241 8.44549 2.29473 8.85415 1.86951 9.28503C1.4462 9.71392 1.25525 10.1402 1.25525 10.5481C1.25525 10.9559 1.4462 11.3822 1.86951 11.8112C2.29473 12.242 2.93241 12.6507 3.75604 13.0037C5.4017 13.709 7.70662 14.1563 10.2762 14.1563C12.8459 14.1563 15.1508 13.709 16.7964 13.0037C17.6201 12.6507 18.2578 12.242 18.683 11.8112C19.1063 11.3822 19.2972 10.9559 19.2972 10.5481C19.2972 10.1402 19.1063 9.71392 18.683 9.28503C18.2578 8.85415 17.6201 8.44549 16.7964 8.0925C15.1508 7.38719 12.8459 6.93994 10.2762 6.93994Z",
    stroke: "#53C1DE",
    strokeWidth: 0.895405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2751 12.2391C11.2093 12.2391 11.9666 11.4818 11.9666 10.5476C11.9666 9.61339 11.2093 8.85608 10.2751 8.85608C9.34093 8.85608 8.58362 9.61339 8.58362 10.5476C8.58362 11.4818 9.34093 12.2391 10.2751 12.2391Z",
    fill: "#53C1DE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2154_19268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2625,
    height: 20.4664,
    fill: "white",
    transform: "translate(0.637695 0.314575)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReact);
export default __webpack_public_path__ + "static/media/react.4bff53f238a83f0c6ec5c2150411030f.svg";
export { ForwardRef as ReactComponent };